module.exports = __webpack_public_path__ + "img/role01.737ee757.png";